
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_1kh1z_3",
  "arrow": "awsui_arrow_18eso_1kh1z_3",
  "has-caret": "awsui_has-caret_18eso_1kh1z_36",
  "placeholder": "awsui_placeholder_18eso_1kh1z_39",
  "pressed": "awsui_pressed_18eso_1kh1z_52",
  "disabled": "awsui_disabled_18eso_1kh1z_55",
  "in-filtering-token": "awsui_in-filtering-token_18eso_1kh1z_64",
  "read-only": "awsui_read-only_18eso_1kh1z_70",
  "invalid": "awsui_invalid_18eso_1kh1z_87"
};
  